import React, { Component } from 'react'
import { Row, Col, Spin, Input, Radio } from 'antd'
import { app, api, config } from "../app"
import Card from "../components/Card"
import Head from "../components/Head"
import Iconz from "../components/Iconz"
import '../css/manual.css'

const RadioGroup = Radio.Group
const RadioButton = Radio.Button

class Manual extends Component {
    constructor (props) {
        super(props)
        this.state = {
            data_load_id: undefined,
            manualList: [],
            manualInfo: {},
            search_name: '',
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleDataList()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据
     * @returns {Promise<void>}
     */
    handleDataList = async () => {
        await this.setData({ loading: true })
        let { search_name } = this.state, params = {
            name: search_name,
            status: '1',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.HandbookLists, params), manualInfo = {}
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (data.length > 0) {
            manualInfo.name = data[0].name
            this.handleDataDetail(data[0].id)
        }
        await this.setData({ loading: false, manualList: data, manualInfo })
    }

    /**
     * 详情数据
     * @returns {Promise<void>}
     */
    handleDataDetail = async (id) => {
        await this.setData({ detail_loading: true, data_load_id: id })
        let params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.HandbookDetails, params)
        if (flag !== 1) {
            app.alert(msg, "error")
        }
        if (id === this.state.data_load_id) {
            await this.setData({ detail_loading: false, manualInfo: data || {} })
        }
    }

    /**
     * 选择手册
     **/
    handleSelectManual = (e) => {
        this.handleDataDetail(e.target.value)
    }

    /**
     * 手册搜索
     **/
    handleSearch = async (search_name) => {
        console.log(search_name)
        await this.setData({search_name})
        await this.handleDataList()
    }


    render () {
        let { data_load_id, manualList, loading, search_status, manualInfo, detail_loading } = this.state,
            card_style = {
                padding: 25,
                height: 'calc(100vh - 228px)',
                borderLeft: '1px solid #eee',
                borderBottom: '1px solid #eee',
                borderRight: '1px solid #eee',
            }
        return (
            <div className="manual">
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48}/>
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history}/>
                <div className="manual-content">
                    <div className="mc-title">使用手册</div>
                    <Row style={{ height: '100%' }}>
                        <Col span={6} style={{ height: '100%' }}>
                            <Card width="100%" height="100%" title="选择手册" style={card_style}>
                                <div style={{ height: '100%' }}>
                                    <Input.Search
                                        placeholder="输入关键词搜索"
                                        onSearch={this.handleSearch}
                                        className="search"
                                    />
                                    {
                                        loading ?
                                            (<Row className="data-loading" type="flex" align="middle"
                                                  justify="center"><Spin/></Row>) :
                                            <RadioGroup onChange={this.handleSelectManual} className="manual-list"
                                                        value={data_load_id}>
                                                {
                                                    manualList.length > 0 ?
                                                        manualList.map((manual, index) => {
                                                            return (
                                                                <RadioButton key={index + 1} className='no-select'
                                                                             value={manual.id}>
                                                                    <div title={manual.name}>{manual.name}</div>
                                                                </RadioButton>
                                                            )
                                                        }) : (
                                                            <p style={{ textAlign: "center", padding: "20px 0" }}>无对应手册</p>)
                                                }
                                            </RadioGroup>
                                    }
                                </div>
                            </Card>
                        </Col>
                        <Col span={17} offset={1}>
                            <Card width="100%" height="100%" title={manualInfo.name || '手册'} style={card_style}>
                                {
                                    detail_loading ?
                                        (<Row className="data-loading" type="flex" align="middle"
                                              justify="center"><Spin size="large"/></Row>) :
                                        <div className="mc-imgs">
                                            {
                                                manualInfo.img && manualInfo.img.map((img, index) => {
                                                    return (
                                                        <div className="mci-img" key={index}>
                                                            <img src={config.imgUrl + img} alt=""/>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div className="mc-remark">{manualInfo.remark}</div>
                                        </div>
                                }
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default Manual



// WEBPACK FOOTER //
// ./src/routes/Manual.jsx